import type { PlanEvent } from "../../../../shared/types";
import { RecurrenceScopeDialog } from "./RecurrenceScopeDialog";
import { RecurrenceActionToast } from "./RecurrenceActionToast";
import type { RecurrenceToastState } from "./RecurrenceActionToast";

interface RecurrenceDialogProps {
  readonly pendingRecurrence: {
    readonly kind: "delete" | "update";
    readonly event: PlanEvent;
    readonly updates?: Partial<
      Pick<
        PlanEvent,
        | "date"
        | "startTime"
        | "endTime"
        | "title"
        | "description"
        | "notes"
        | "tags"
        | "recurrence"
        | "reminderMinutes"
        | "category"
      >
    >;
  } | null;
  readonly pendingResync: PlanEvent | null;
  readonly recurrenceToast: RecurrenceToastState | null;
  readonly onRecurrenceChoice: (action: "this" | "all") => void;
  readonly onResyncChoice: (action: "this" | "all") => void;
  readonly onClosePendingRecurrence: () => void;
  readonly onClosePendingResync: () => void;
  readonly onDismissToast: () => void;
}

export function RecurrenceDialog({
  pendingRecurrence,
  pendingResync,
  recurrenceToast,
  onRecurrenceChoice,
  onResyncChoice,
  onClosePendingRecurrence,
  onClosePendingResync,
  onDismissToast,
}: RecurrenceDialogProps) {
  return (
    <>
      <RecurrenceScopeDialog
        open={pendingRecurrence !== null}
        mode={pendingRecurrence?.kind === "delete" ? "delete" : "move"}
        onThis={() => onRecurrenceChoice("this")}
        onAll={() => onRecurrenceChoice("all")}
        onCancel={onClosePendingRecurrence}
      />

      <RecurrenceScopeDialog
        open={pendingResync !== null}
        mode="resync"
        onThis={() => onResyncChoice("this")}
        onAll={() => onResyncChoice("all")}
        onCancel={onClosePendingResync}
      />

      <RecurrenceActionToast
        toast={recurrenceToast}
        onDismiss={onDismissToast}
      />
    </>
  );
}
